import React from 'react';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import SortingIcon from '../UI/SortingIcon';

const productSystemTableHeadRohr = (props) => {

  const ct = useCustomTranslation();

  const filterCol = (col) => {
    props.onFilterTableColumnsAction(col)
  }

  return (
    <thead>
      <tr>
        <th onClick={()=>filterCol('penetrations')} scope="col" className="colLeft sortableColumnHeadline">
          <SortingIcon
            currentColumn={'penetrations'}
            sortColumn={props.sortColumn}
            sortDirection={props.sortDirection} />
            { ct('wizard.steps.product_solution.tube.table.header.penetrations.long') }</th>
        <th className={"colLeft " + props.color} colSpan={3} style={{width: "120px"}}>{ ct('wizard.steps.product_solution.tube.table.header.quantity.long') }</th>
        <th scope="col" style={{width: "120px"}}>{ ct('wizard.steps.product_solution.tube.table.header.durchmesser.long') }</th>
        <th scope="col" style={{width: "100px"}}>{ ct('wizard.steps.product_solution.tube.table.header.wandstaerke.long') }</th>
        <th onClick={()=>filterCol('insulation')} scope="col" className="colLeft sortableColumnHeadline">
          <SortingIcon
            currentColumn={'insulation'}
            sortColumn={props.sortColumn}
            sortDirection={props.sortDirection} />
          { ct('wizard.steps.product_solution.tube.table.header.isolierung.long') }</th>
        <th scope="col" style={{width: "100px"}}>{ ct('wizard.steps.product_solution.tube.table.header.isolierstaerke.long') }</th>
        <th scope="col" style={{width: "100px"}}>{ ct('wizard.steps.product_solution.tube.table.header.isolierlaenge.long') }</th>
        <th onClick={()=>filterCol('product_name')}  scope="col" className="colLeft sortableColumnHeadline">
          <SortingIcon
            currentColumn={'product_name'}
            sortColumn={props.sortColumn}
            sortDirection={props.sortDirection} />
          { ct('wizard.steps.product_solution.tube.table.header.produkt.long') }</th>
        <th scope="col" style={{width: "90px"}}>{ ct('wizard.steps.product_solution.tube.table.header.fwk.long') }</th>
        <th scope="col" className="colLeft" style={{width: "100px"}}>{ ct('wizard.steps.product_solution.tube.table.header.verweis.long') }</th>
      </tr>
    </thead>
  )
};


export default productSystemTableHeadRohr;



// WEBPACK FOOTER //
// ./src/components/Shared/ProductSystemTableHeadRohr.js